import { api } from './api';

export const managementApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUser: builder.mutation({
      query: ({
        filter,
        filterKey,
        headerFilters,
        order,
        orderBy,
        userId,
        userIndex,
        dateRange,
      }) => {
        return {
          url: 'getUser',
          method: 'POST',
          body: {
            filter,
            filterKey,
            headerFilters,
            order,
            orderBy,
            userId,
            userIndex,
            dateRange,
          },
        };
      },
    }),

    saveUser: builder.mutation({
      query: (userData) => {
        return {
          url: 'saveUser',
          method: 'POST',
          body: userData,
        };
      },
    }),

    deleteUser: builder.mutation({
      query: ({
        userId,
        order,
        orderBy,
        filter,
        pageIndex,
        pageSize,
      }) => {
        return {
          url: 'deleteUser',
          method: 'POST',
          body: {
            userId,
            order,
            orderBy,
            filter,
            pageIndex,
            pageSize,
          },
        };
      },
    }),

    getUsers: builder.query({
      query: ({
        order,
        orderBy,
        filter,
        filterKey,
        headerFilters,
        pageIndex,
        pageSize,
        dateRange,
      }) => {
        return {
          url: 'getUsers',
          method: 'POST',
          body: {
            order,
            orderBy,
            filter,
            filterKey,
            headerFilters,
            pageIndex,
            pageSize,
            dateRange,
          },
        };
      },
    }),

    getAllCheckoutAsUsers: builder.query({
      query: () => {
        return {
          url: 'getAllCheckoutAsUsers',
        };
      },
    }),

    updateUser: builder.mutation({
      query: ({
        userId,
        diffs,
      }) => {
        return {
          url: 'updateUser',
          method: 'POST',
          body: {
            userId,
            diffs,
          },
        };
      },
    }),

  }),
});

export const {
  useGetUserMutation,
  useSaveUserMutation,
  useDeleteUserMutation,
  useGetUsersQuery,
  useGetAllCheckoutAsUsersQuery,
  useUpdateUserMutation,
} = managementApi;
